/**
 * Shared utilities for templates
 */
import type { TemplateField, QuotaCalculator } from './types'

// ============================================================================
// Default Fields
// ============================================================================

export const DEFAULT_FIELDS: TemplateField[] = [
    { key: 'cpu', names: ['cpu', 'vcore', 'vcpu'], label: 'CPU' },
    { key: 'memory', names: ['memory', 'ram'], label: 'Memory' },
    { key: 'disk', names: ['disk', 'ssd', 'hdd', 'storage'], label: 'Storage' },
    { key: 'ip', names: ['ip', 'ip-address', 'ipv4', 'ipv6'], label: 'IP' },
    { key: 'bandwidth', names: ['bandwidth', 'bw'], label: 'Bandwidth' },
]

// ============================================================================
// Quota Calculators
// ============================================================================

/**
 * Default quota calculator: commitment_value only
 */
export const defaultQuotaCalculator: QuotaCalculator = (config) => {
    return config?.commitment_value || 0
}

/**
 * Capacity quota calculator: capacity_value * commitment_value
 * Used by Server.VBM, Server.Colocation
 */
export const capacityQuotaCalculator: QuotaCalculator = (config) => {
    const capacity = config?.capacity_value || 1
    const commitment = config?.commitment_value || 0
    return capacity * commitment
}

// ============================================================================
// Expandable Checkers
// ============================================================================

/**
 * Default expandable check: has addons
 */
export const defaultIsExpandable = (row: any): boolean => {
    return (row?.addons || []).length > 0
}

/**
 * Config-based expandable check: has configoptions or addons
 */
export const configBasedIsExpandable = (row: any): boolean => {
    const hasConfigs = (row?.configoptions || []).length > 0
    const hasAddons = (row?.addons || []).length > 0
    return hasConfigs || hasAddons
}

/**
 * Commitment-based expandable check: has commitment configs
 * Used by VCloud
 */
export const commitmentBasedIsExpandable = (row: any): boolean => {
    const hasCommitmentConfigs = (row?.configoptions || []).some(
        (c: any) =>
            c.commitment_value !== null &&
            c.commitment_value !== undefined &&
            c.commitment_value > 0
    )
    const hasAddonConfigs = (row?.addons || []).some((addon: any) =>
        (addon.configoptions || []).some(
            (c: any) =>
                c.commitment_value !== null &&
                c.commitment_value !== undefined &&
                c.commitment_value > 0
        )
    )
    return hasCommitmentConfigs || hasAddonConfigs
}
